findUncaughtFrozen